/* OKB free gift: popup + auto rules for "Orders Above 350 AED Gets Free Gift" */
(function () {
  if (window.OKBGift) return;

  var cfgEl = document.getElementById('okb-gift-config');
  var modal = document.getElementById('okb-gift-modal');
  if (!cfgEl || !modal) return;

  var CFG;
  try {
    CFG = JSON.parse(cfgEl.textContent);
  } catch (e) {
    return;
  }
  var T = CFG.t;
  var PROP = CFG.prop;
  var GIFTS = (CFG.gifts || []).filter(function (g) { return g && g.available && g.variantId; });
  if (!GIFTS.length) return;
  var GIFT_PIDS = GIFTS.map(function (g) { return g.productId; });
  // '1' = popup already shown/answered since the cart last went over 350 AED.
  // Reset whenever the cart drops below 350 (or is emptied), so it pops up again next time.
  var DISMISS_KEY = 'okb_gift_shown';
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var pending = null;
  var timer = null;
  var hadTagged = null;
  var lastFocus = null;

  /* ---------- helpers ---------- */
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function cartUrl() {
    return (window.routes && window.routes.cart_url) || CFG.cartUrl || '/cart';
  }
  function json(url, body) {
    var opts = { headers: { Accept: 'application/json' } };
    if (body) {
      opts.method = 'POST';
      opts.headers['Content-Type'] = 'application/json';
      opts.body = JSON.stringify(body);
    }
    return nativeFetch(url, opts).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw data;
        return data;
      });
    });
  }
  function getCart() { return json(root() + 'cart.js'); }
  function updateCart(updates) { return json(root() + 'cart/update.js', { updates: updates }); }

  function isGiftProduct(item) { return GIFT_PIDS.indexOf(item.product_id) !== -1; }
  function isTagged(item) { return !!(item.properties && item.properties[PROP]); }
  function isDiscounted(item) { return item.final_line_price < item.original_line_price; }

  function analyse(cart) {
    var sub = 0;
    var tagged = [];
    var discountedGift = false;
    cart.items.forEach(function (item) {
      if (isGiftProduct(item)) {
        if (isTagged(item)) tagged.push(item);
        if (isDiscounted(item)) discountedGift = true;
      } else {
        sub += item.final_line_price;
      }
    });
    return { sub: sub, eligible: sub >= CFG.threshold, tagged: tagged, hasGift: discountedGift };
  }

  /* ---------- cart UI refresh (Dawn) ---------- */
  function parse(html, selector) {
    var el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function refreshUI(cart, openDrawer) {
    var itemsEl = document.getElementById('main-cart-items');
    var footerEl = document.getElementById('main-cart-footer');
    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-icon-bubble'];
    if (drawer) sections.push('cart-drawer');
    if (itemsEl && itemsEl.dataset.id) sections.push(itemsEl.dataset.id);
    if (footerEl && footerEl.dataset.id) sections.push(footerEl.dataset.id);

    return nativeFetch(cartUrl() + '?sections=' + sections.join(','))
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var empty = cart.item_count === 0;

        var bubble = document.getElementById('cart-icon-bubble');
        var bubbleHtml = s['cart-icon-bubble'] && parse(s['cart-icon-bubble'], '.shopify-section');
        if (bubble && bubbleHtml !== null) bubble.innerHTML = bubbleHtml;

        if (itemsEl && s[itemsEl.dataset.id]) {
          if (empty) return window.location.reload();
          var a = itemsEl.querySelector('.js-contents');
          var aHtml = parse(s[itemsEl.dataset.id], '.js-contents');
          if (a && aHtml !== null) a.innerHTML = aHtml;
          var b = footerEl && footerEl.querySelector('.js-contents');
          var bHtml = footerEl && s[footerEl.dataset.id] && parse(s[footerEl.dataset.id], '.js-contents');
          if (b && bHtml) b.innerHTML = bHtml;
        }

        if (drawer && s['cart-drawer']) {
          if (openDrawer && !itemsEl && typeof drawer.renderContents === 'function') {
            drawer.renderContents({ sections: s });
          } else {
            var inner = document.getElementById('CartDrawer');
            var innerHtml = parse(s['cart-drawer'], '#CartDrawer');
            if (inner && innerHtml !== null) {
              inner.innerHTML = innerHtml;
              var overlay = drawer.querySelector('#CartDrawer-Overlay');
              if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
            }
            drawer.classList.toggle('is-empty', empty);
          }
        }
      })
      .catch(function () {
        if (itemsEl) window.location.reload();
      });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('okb-gift-toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4500);
  }

  /* ---------- modal ---------- */
  var grid = modal.querySelector('.okb-gift-modal__grid');
  var errEl = modal.querySelector('.okb-gift-modal__error');
  modal.querySelector('.okb-gift-modal__title').textContent = T.title;
  modal.querySelector('.okb-gift-modal__sub').textContent = T.sub;
  modal.querySelector('.okb-gift-modal__skip').textContent = T.noThanks;
  modal.querySelector('.okb-gift-modal__close').setAttribute('aria-label', T.close);

  function renderCards(selectedVariantId) {
    grid.innerHTML = '';
    GIFTS.forEach(function (g) {
      var selected = String(g.variantId) === String(selectedVariantId);
      var card = document.createElement('div');
      card.className = 'okb-gift-card' + (selected ? ' is-selected' : '');

      var img = document.createElement('img');
      img.className = 'okb-gift-card__img';
      img.src = g.image;
      img.alt = g.title;
      img.loading = 'lazy';
      img.width = 400;
      img.height = 400;

      var title = document.createElement('p');
      title.className = 'okb-gift-card__title';
      title.textContent = g.title;

      var price = document.createElement('p');
      price.className = 'okb-gift-card__price';
      var s = document.createElement('s');
      s.textContent = g.price;
      var strong = document.createElement('strong');
      strong.textContent = T.free;
      price.appendChild(s);
      price.appendChild(strong);

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'okb-gift-card__btn';
      btn.textContent = selected ? T.selected : T.add;
      btn.disabled = selected;
      btn.addEventListener('click', function () { chooseGift(g, btn); });

      card.appendChild(img);
      card.appendChild(title);
      card.appendChild(price);
      card.appendChild(btn);
      grid.appendChild(card);
    });
  }

  function isOpen() { return !modal.hidden; }

  function openModal(selectedVariantId) {
    renderCards(selectedVariantId);
    errEl.hidden = true;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('okb-gift-lock');
    var first = modal.querySelector('.okb-gift-card__btn:not([disabled])') || modal.querySelector('.okb-gift-modal__close');
    if (first) setTimeout(function () { first.focus(); }, 50);
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('okb-gift-lock');
    if (lastFocus && lastFocus.focus && document.contains(lastFocus)) lastFocus.focus();
  }

  function dismiss() {
    ssSet(DISMISS_KEY, '1');
    closeModal();
  }

  modal.addEventListener('click', function (e) {
    if (e.target.closest('[data-okb-gift-dismiss]')) dismiss();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) dismiss();
  });

  // "Choose your gift" / "Change" buttons in the cart bar (re-rendered often, so delegate)
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-okb-gift-open]');
    if (!trigger) return;
    e.preventDefault();
    getCart().then(function (cart) {
      var a = analyse(cart);
      openModal(a.tagged[0] ? a.tagged[0].variant_id : null);
    });
  });

  function setButtons(disabled, activeBtn) {
    grid.querySelectorAll('.okb-gift-card__btn').forEach(function (b) {
      b.disabled = disabled;
    });
    if (activeBtn) activeBtn.textContent = disabled ? T.adding : T.add;
  }

  function chooseGift(gift, btn) {
    if (busy) return;
    busy = true;
    errEl.hidden = true;
    setButtons(true, btn);

    getCart()
      .then(function (cart) {
        // remove any previous gift picked through the popup (swap)
        var updates = {};
        var any = false;
        analyse(cart).tagged.forEach(function (item) { updates[item.key] = 0; any = true; });
        return any ? updateCart(updates) : null;
      })
      .then(function () {
        var props = {};
        props[PROP] = '1';
        return json(root() + 'cart/add.js', { items: [{ id: gift.variantId, quantity: 1, properties: props }] });
      })
      .then(getCart)
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return isTagged(i) && i.variant_id === gift.variantId; })[0];
        if (line && isDiscounted(line)) {
          hadTagged = true;
          closeModal();
          return refreshUI(cart, true);
        }
        // Shopify didn't apply the discount: undo so the customer is never charged unexpectedly
        var undo = {};
        if (line) undo[line.key] = 0;
        return (line ? updateCart(undo) : getCart()).then(function (c) {
          hadTagged = false;
          ssSet(DISMISS_KEY, '1');
          errEl.textContent = T.notApplied;
          errEl.hidden = false;
          setButtons(false, btn);
          return refreshUI(c, false);
        });
      })
      .catch(function () {
        errEl.textContent = T.error;
        errEl.hidden = false;
        setButtons(false, btn);
      })
      .then(function () {
        busy = false;
      });
  }

  /* ---------- rules engine ---------- */
  function evaluate(fromChange) {
    if (busy) {
      pending = pending || fromChange;
      return;
    }
    busy = true;

    getCart()
      .then(function (cart) {
        var a = analyse(cart);
        var updates = {};
        var changed = false;
        var removedForThreshold = false;
        var notFree = false;

        if (a.tagged.length) {
          if (!a.eligible) {
            a.tagged.forEach(function (i) { updates[i.key] = 0; });
            changed = true;
            removedForThreshold = true;
          } else if (!isDiscounted(a.tagged[0])) {
            // Shopify is not making the gift free (e.g. another discount won): never charge for it
            a.tagged.forEach(function (i) { updates[i.key] = 0; });
            changed = true;
            notFree = true;
          } else {
            a.tagged.forEach(function (i, idx) {
              var want = idx === 0 ? 1 : 0; // only one gift, quantity 1
              if (i.quantity !== want) {
                updates[i.key] = want;
                changed = true;
              }
            });
          }
        } else if (hadTagged && a.eligible) {
          // customer removed the gift themselves: don't push the popup again
          ssSet(DISMISS_KEY, '1');
        }
        hadTagged = a.tagged.length > 0 && !removedForThreshold && !notFree;

        if (changed) {
          if (removedForThreshold) ssSet(DISMISS_KEY, '0');
          return updateCart(updates).then(function (newCart) {
            if (removedForThreshold) toast(T.removed);
            if (notFree) { ssSet(DISMISS_KEY, '1'); toast(T.notApplied); }
            return refreshUI(newCart, false);
          });
        }

        if (!a.eligible) {
          ssSet(DISMISS_KEY, '0'); // below 350 / empty cart: allow the popup again next time
          if (isOpen()) closeModal();
          return;
        }

        if (!a.hasGift && !a.tagged.length && !isOpen() && ssGet(DISMISS_KEY) !== '1') {
          ssSet(DISMISS_KEY, '1'); // show once per time the cart crosses 350
          openModal(null);
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending !== null) {
          var p = pending;
          pending = null;
          schedule(p);
        }
      });
  }

  function schedule(fromChange) {
    clearTimeout(timer);
    timer = setTimeout(function () { evaluate(fromChange); }, 450);
  }

  /* ---------- watch every cart change (theme + apps) ---------- */
  window.fetch = function (input, init) {
    var p = nativeFetch(input, init);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_RE.test(url)) {
        p.then(function () { schedule(true); }, function () {});
      }
    } catch (e) {}
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try {
      if (CART_RE.test(String(url))) {
        this.addEventListener('load', function () { schedule(true); });
      }
    } catch (e) {}
    return xhrOpen.apply(this, arguments);
  };

  // Dawn's own cart events (backup for themes/apps that bypass fetch patching)
  document.addEventListener('DOMContentLoaded', function () {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { schedule(true); });
      }
    } catch (e) {}
  });

  window.OKBGift = { open: function () { openModal(null); }, evaluate: evaluate };

  // first pass on page load (also catches add-to-cart forms that reload the page)
  evaluate(false);
})();
